import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Box, Backdrop, Typography, Button } from '@mui/material';

import { FeeSchedule } from '../../types/FeeSchedule';

import FeeSchedulePopup from './components/FeeSchedulePopup';
import FeeSchedulesTable from './components/FeeSchedulesTable';

const FeeSchedulesScreen: React.FC = () => {
  const [showPopup, setShowPopup] = React.useState(false);
  const [selectedFeeSchedule, setSelectedFeeSchedule] = React.useState<
    FeeSchedule | undefined
  >(undefined);

  return (
    <Box className='white-background min-height-100'>
      <Box className='content-wrapper'>
        <Box className='row-wrapper'>
          <h3>Fee Schedules</h3>
          <Button
            onClick={() => {
              setSelectedFeeSchedule(undefined);
              setShowPopup(true);
            }}
            startIcon={<AddIcon htmlColor='#ffffff' />}
            disableElevation
            color='primary'
            variant='contained'
            sx={{
              borderRadius: '40px',
              px: '40px',
              height: '50px',
              marginLeft: '24px',
            }}
          >
            <Typography color='white'>Add Fee Schedule</Typography>
          </Button>
        </Box>
        <FeeSchedulesTable
          onSelect={(schedule) => {
            setSelectedFeeSchedule(schedule);
            setShowPopup(true);
          }}
        />
        <Backdrop
          open={showPopup}
          sx={{
            color: '#fff',
            zIndex: 99,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <FeeSchedulePopup
            feeSchedule={selectedFeeSchedule}
            onClose={() => setShowPopup(false)}
          />
        </Backdrop>
      </Box>
    </Box>
  );
};

export default FeeSchedulesScreen;
